module.exports = __webpack_public_path__ + "img/bgc4.e0964aa3.png";